import client from "../modules/client";
import HelperService from "./helper-service";

export const search = (filter) => {
  let query = HelperService.getFilterQueryString({
    limit: 20,
    //keyword: filter.search,
    radius: HelperService.getRadius(filter),
    lat: filter.lat,
    lon: filter.lon,
    search: filter.search,
    age: filter.age,
    datetimeFrom: filter.datetimeFrom || (new Date()).getTime(),
    datetimeTo: filter.datetimeTo,
    duration: filter.duration,
    daypart: filter.daypart,
    sweatequity: filter.sweatequity,
    difficulty: filter.difficulty,
    sweatmeter: filter.sweatmeter,
    popup: filter.popup,
    special: filter.special,
    categories: filter.categories,
    excludeCategories: filter.excludeCategories,
  });
  if (!filter?.search || filter?.search?.length<3){
    return Promise.resolve([]);
  }
  return client(`/api/v0/search/${filter.search}?${query}`)
      .then(({ data }) => data?.classes);
};

export function useSearchService () {
  return {
    search,
  };
}
